<div class="result-siderspace">
    <div class="back-icon cursor-pointer" (click)="backButtoEvent()">
        <i class="fa-solid fa-arrow-left-long"></i>
    </div>
    <div class="result-fulltop-view mb-3">
        <div class="result-fulltop-view-wrap">
            <div class="row align-items-center">
                <div class="col-xl-3 col-lg-6 col-md-6 leftsidedivider position-relative">
                    <div class="resulttestlabel">
                        <p>Name Of Test</p>
                        <span><b>{{StudentResult.examName}}</b></span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Date</p>
                        <span>{{StudentResult.examStartDate | date: 'dd/MM/yyyy'}}</span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Test Duration</p>
                        <span>{{ timeConvert(StudentResult.durationInMins)}}</span>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 leftsidedivider position-relative ps-md-3 ps-xl-5">
                    <div class="resulttestlabel">
                        <p>Start Time</p>
                        <span>{{StudentResult.examStartDate | date: 'hh : mm : ss a'}}</span>
                    </div>
                    <div class="resulttestlabel">
                        <p>End Duration</p>
                        <span>{{StudentResult.examEndDate | date: 'hh : mm : ss a'}}</span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Time Taken</p>
                        <span>{{ timeConvert(StudentResult.timeTaken)}}</span>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 leftsidedivider position-relative ps-md-3 ps-xl-5">
                    <div class="resulttestlabel">
                        <p>Score</p>
                        <span>{{StudentResult.correctAns}}/{{AllQuestionsList.length}}</span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Percentage</p>
                        <span class="percentage-field">
                            <div class="progress">
                                <div class="progress-bar" role="progressbar"
                                    [style.width.%]="calculatedPercentage(StudentResult.correctAns, AllQuestionsList.length)"
                                    [attr.aria-valuenow]="calculatedPercentage(StudentResult.correctAns, AllQuestionsList.length)"
                                    aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="progress-label">{{ calculatedPercentage(StudentResult.correctAns,
                                AllQuestionsList.length) | number:'1.0-2' }}%</div>
                        </span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Submit Type</p>
                        <span>{{StudentResult.submitType}}</span>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-6 col-md-6 leftsidedivider position-relative ps-md-3 ps-xl-4">
                    <div class="testresult-status" *ngIf="StudentResult.isPass">Pass</div>
                    <div class="testresult-status-fail" *ngIf="!StudentResult.isPass">Fail</div>
                </div>
            </div>
        </div>
    </div>
    <div class="testresult-fullcontent">
        <div class="row">
            <div class="col-xl-4 col-12">
                <div class="testresult-view-leftsidebar">
                    <h4>Exam Result</h4>
                    <div class="studentprofile-view d-flex align-items-center mb-3 pb-3">
                        <div class="profileavtar">
                            <img src="../../../../assets/img/avtar-img.png" alt="avtar"
                                *ngIf="StudentResult.photo == null" class="img-fluid">
                            <img [src]="StudentResult.photo" alt="avtar" *ngIf="StudentResult.photo != null"
                                class="img-fluid">
                        </div>
                        <div class="profiledesc">
                            <h3>{{StudentResult.studentName}}</h3>
                            <p><i class="fa-solid fa-building-columns me-2"></i>{{StudentResult.collegeName}}</p>
                            <p><i class="fa-solid fa-phone me-2"></i>+91 {{StudentResult.mobileNo}}</p>
                        </div>
                    </div>
                    <div class="resulttestlabel">
                        <p>Total Number of Questions</p>
                        <span><b>{{AllQuestionsList.length}}</b></span>
                    </div>
                    <div class="resulttestlabel">
                        <p>Passing Marks</p>
                        <span><b>{{StudentResult.cutOff}}</b></span>
                    </div>
                    <div class="correctwronginfo">
                        <ul class="mb-3 pb-3">
                            <li><i class="fa-solid fa-circle" style="color:#89FE87;"></i>Answered<b>:
                                    {{StudentResult.correctAns + StudentResult.wrongAns}}</b></li>
                            <li><i class="fa-solid fa-circle" style="color:#FFB6B6;"></i>Wrong<b>:
                                    {{StudentResult.wrongAns}}</b></li>
                            <li><i class="fa-solid fa-circle"
                                    style="color:#FFDF8C;"></i>Skipped<b>:{{AllQuestionsList.length - (
                                    StudentResult.correctAns + StudentResult.wrongAns)}}</b></li>
                        </ul>
                        <div class="listingofresult">
                            <ul>
                                <li [ngClass]="{
                                    'rightans': question.isCorrect,
                                    'wrongans':!question.isCorrect && !question.isSkipped,
                                    'skipans': question.isSkipped
                                  }" *ngFor="let question of AllQuestionsList; let i = index">{{i+1}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-12">
                <div class="questionanswerlist mt-4 mt-lg-3">
                    <div class="queans-wrap-list" *ngFor="let question of QuestionsList; let i = index">
                        <div *ngIf="question.questionTypeId != 5">
                            <div class="questionno">Q-{{i+1}}.</div>
                            <div class="row d-flex align-items-end px-md-3 px-0" [ngClass]="{
                            'singlequetype': question.questionTypeId == this.enum.SingleSelection || question.questionTypeId == this.enum.MultiSelection,
                            'singlequewithimgtype': question.questionTypeId == this.enum.ImageWithSingleSelection || question.questionTypeId == this.enum.ImageWithMultiSelection
                          }">
                                <div class="col-xl-2 col-lg-3 col-sm-4 align-self-center"
                                    *ngIf="question.questionTypeId == this.enum.ImageWithSingleSelection || question.questionTypeId == this.enum.ImageWithMultiSelection">
                                    <div class="queimg">
                                        <img [src]="question.imageUrl ? question.imageUrl : '../../../../assets/img/avtar-img.png'"
                                            alt="image not found" class="img-fluid">
                                    </div>
                                </div>
                                <div class="" [ngClass]="{
                                'col-lg-10': question.questionTypeId == this.enum.SingleSelection || question.questionTypeId == this.enum.MultiSelection,
                                'col-xl-8 col-lg-7 col-sm-6  align-self-center': question.questionTypeId == this.enum.ImageWithSingleSelection || question.questionTypeId == this.enum.ImageWithMultiSelection
                              }">
                                    <h5>{{question.questionText}}</h5>
                                    <div class="queoption">
                                        <ul>
                                            <li *ngFor="let option of question.options; let j = index">
                                                <div class="form-check"
                                                    *ngIf="question.questionTypeId==this.enum.SingleSelection || question.questionTypeId==this.enum.ImageWithSingleSelection || question.questionTypeId==this.enum.ParagraphWithSingleSelection">
                                                    <input class="form-check-input checkbox-round" type="checkbox"
                                                        name="flexRadioDefault + j" id="{{ 'option' + j }}"
                                                        [checked]="option.isSelectedOption" [ngClass]="{
                                                    'bg-success' :option.isCorrectOption && option.isSelectedOption,
                                                    'bg-danger':!option.isCorrectOption && option.isSelectedOption}"
                                                        (click)="stopCheckingStates($event)">

                                                    <label class="form-check-label" for="{{ 'option' + j }}">
                                                        {{option.optionText}}
                                                    </label>
                                                </div>
                                                <div class="form-check"
                                                    *ngIf="question.questionTypeId==this.enum.MultiSelection ||  question.questionTypeId==this.enum.ImageWithMultiSelection">
                                                    <input class="form-check-input checkbox-round" type="checkbox"
                                                        name="flexCheckDefault + j" id="{{ 'optionCheck' + j }}"
                                                        [checked]="option.isSelectedOption">
                                                    <label class="form-check-label" for="{{ 'optionCheck' + j }}">
                                                        {{option.optionText}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="correctans" *ngIf="question.isCorrect"><i
                                            class="fa-solid fa-check pe-2"></i>Correct</div>
                                    <div class="correctans wrong" *ngIf="!question.isCorrect && !question.isSkipped"><i
                                            class="fa-solid fa-xmark pe-2"></i>Wrong</div>
                                    <div class="correctans skipped" *ngIf="question.isSkipped"><i
                                            class="fa-solid fa-forward-step pe-2"></i>Skipped</div>
                                </div>
                            </div>
                            <div class="row px-md-3 px-0">
                                <div class="col-sm-9 col-12">
                                    <div class="anscorrection" *ngIf="!question.isCorrect && !question.isSkipped">
                                        - Correction answer is.. {{correctAns(question.options)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="question.questionTypeId == 5">
                            <div class="paragraph-quetype">
                                <h4>PARAGRAPH</h4>
                                <p>{{question.pargaraphText}}</p>
                            </div>
                            <div class="paragraph-queans-wrap-list"
                                *ngFor="let paragraphQue of QuestionsList[i].paragraphQuestion; let x = index">
                                <div class="questionno">Q-{{i+x+1}}.</div>
                                <div class="row d-flex align-items-end mb-3 px-md-3 px-0">
                                    <div class="col-lg-10">
                                        <h5>{{paragraphQue.questionText}}</h5>
                                        <div class="queoption">
                                            <ul>
                                                <li *ngFor="let paragraphOption of paragraphQue.options; let j = index">
                                                    <div class="form-check"
                                                        *ngIf="paragraphQue.questionTypeId==this.enum.SingleSelection || paragraphQue.questionTypeId==this.enum.ParagraphWithSingleSelection">
                                                        <input class="form-check-input checkbox-round" type="checkbox"
                                                            name="flexRadioDefault + j" id="{{ 'option' + j }}"
                                                            [checked]="paragraphOption.isSelectedOption"
                                                            [ngClass]="{
                                                    'bg-success' :paragraphOption.isCorrectOption && paragraphOption.isSelectedOption,
                                                    'bg-danger':!paragraphOption.isCorrectOption && paragraphOption.isSelectedOption}"
                                                            (click)="stopCheckingStates($event)">

                                                        <label class="form-check-label" for="{{ 'option' + j }}">
                                                            {{paragraphOption.optionText}}
                                                        </label>
                                                    </div>
                                                    <div class="form-check"
                                                        *ngIf="paragraphQue.questionTypeId==this.enum.MultiSelection">
                                                        <input class="form-check-input checkbox-round" type="checkbox"
                                                            name="flexCheckDefault + j" id="{{ 'optionCheck' + j }}"
                                                            [checked]="paragraphOption.isSelectedOption">
                                                        <label class="form-check-label" for="{{ 'optionCheck' + j }}">
                                                            {{paragraphOption.optionText}}
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="correctans" *ngIf="paragraphQue.isCorrect"><i
                                                class="fa-solid fa-check pe-2"></i>Correct</div>
                                        <div class="correctans wrong"
                                            *ngIf="!paragraphQue.isCorrect && !paragraphQue.isSkipped"><i
                                                class="fa-solid fa-xmark pe-2"></i>Wrong</div>
                                        <div class="correctans skipped" *ngIf="paragraphQue.isSkipped"><i
                                                class="fa-solid fa-forward-step pe-2"></i>Skipped</div>
                                    </div>
                                </div>
                                <div class="row px-md-3 px-0 mb-3">
                                    <div class="col-sm-9 col-12">
                                        <div class="anscorrection"
                                            *ngIf="!paragraphQue.isCorrect && !paragraphQue.isSkipped">
                                            - Correction answer is.. {{correctAns(paragraphQue.options)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>